import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import HeadingWithIcon from 'pages/projects/kanban/shared/HeadingWithIcon';
import { useAuth } from 'contexts/AuthContext';
import { useSocket } from '../../context/SocketContext';
import { CHECK_SQUARE2_ICON } from '../../assets/image';
import Tasks from './Tasks';
import style from './Tasks.module.css';
import Axios from '../../utils/Axios';
import boardToast, { TOAST_TYPE } from '../../utils/boardToast';
import { createProjectBoardSocket } from 'utils/Helpers';
import ChecklistSection from './ChecklistSection';
import ChecklistContainer from './ChecklistContainer';
import plusIcon from 'assets/img/plusIcon.svg';

export default function TaskWrapper({
  milestoneId,
  viewMode,
  members,
  projectBoardId,
  isSubTask,
  statusOptions,
  fetchSubtask,
  showSubTask,
  subTaskId,
  subTask,
  setTotalSubtasks,
  setChecklistItems,
  isTemplateActive = false,
  selectedMilestone = null,
  milestone,
  isMasterCalender,
  masterCalenderSocket,
  reminderOptions,
  isChecklistFullscreen,
  setIsChecklistFullscreen
}) {
  const socket = useSocket();
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [subTasks, setSubTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [filteredSubTasks, setFilteredSubTasks] = useState([]);
  const [isMyTaskChecked, setIsMyTaskChecked] = useState(false);
  const [isDeleting, setDeleting] = useState(false);

  const fetchTasks = useCallback(async () => {
    try {
      const response = await Axios.get(`/milestone-task/view/${milestoneId}`);
      if (response.length > 0) {
        setTasks(response);
        setFilteredTasks(response);
        setChecklistItems(response);
      }
    } catch (error) {
      boardToast('Something went wrong to fetching tasks!', TOAST_TYPE.ERROR);
    }
  }, [milestoneId]);

  // const fetchSubTasks = useCallback(async () => {
  //   try {
  //     const response = await Axios.get(`/milestone-subtask/${milestoneId}`);
  //     if (response.length > 0) {
  //       setSubTasks(response);
  //       setFilteredSubTasks(response);
  //       if (setTotalSubtasks) {
  //         setTotalSubtasks(response);
  //       }
  //     }
  //   } catch (error) {
  //     boardToast('Something went wrong to fetching subtasks!', TOAST_TYPE.ERROR);
  //   }
  // }, [milestoneId]);

  const handleAddTaskcsection = (milestoneId) => {
    socket.emit(
      'add-checklist',
      {
        name: 'root checklist 1',
        milestoneId: '6967c543b7de169bab35ff4b',
        parentChecklistId: '698cb33f068176889fc2ecaa'
        // parentChecklistId: null // rootdueDate: '2026-03-15',
      },
      projectBoardId
    );
  };

  useEffect(() => {
    if (showSubTask) {
      setTasks(subTask?.checklist);
      setFilteredTasks(subTask?.checklist);
      // } else if (isTemplateActive && selectedMilestone) {
    } else {
      setTasks(selectedMilestone?.checklist || []);
      setFilteredTasks(selectedMilestone?.checklist || []);
      setChecklistItems(selectedMilestone?.checklist || []);
      setSubTasks(selectedMilestone?.subtask || []);
      setTotalSubtasks(selectedMilestone?.subtask || []);
      setFilteredSubTasks(selectedMilestone?.subtask || []);
      // console.log(selectedMilestone?.assignees);
      // fetchTasks();
      // fetchSubTasks();
    }
    // else {
    //   console.log(milestone, 'aaaaaaaaaaaaaa');
    //   setTasks(milestone?.checklist);
    //   setFilteredTasks(milestone?.checklist);
    //   setChecklistItems(milestone?.checklist || []);

    // }
  }, [fetchTasks, subTask]);

  useEffect(() => {
    let mastersocket = socket;
    if (isMasterCalender) {
      mastersocket = masterCalenderSocket;
    }
    if (mastersocket == null) return;
    const handle_checklist = (data) => {
      if (data[0]?.subtaskId === subTaskId && showSubTask) {
        setTasks(data);
        setFilteredTasks(data);
        if (setChecklistItems) {
          setChecklistItems(data);
        }
      } else if (data[0]?.milestoneId === milestoneId) {
        setTasks(data);
        setFilteredTasks(data);
        if (setChecklistItems) {
          setChecklistItems(data);
        }
      }
      if (data.length === 0) {
        setTasks([]);
        setFilteredTasks([]);
        if (setChecklistItems) {
          setChecklistItems([]);
        }
      }
    };
    const handle_subtasks = (data) => {
      if (data[0]?.milestoneId === milestoneId) {
        console.log('subtasks', data);

        setSubTasks(data);
        setFilteredSubTasks(data);
        if (setTotalSubtasks) {
          setTotalSubtasks(data);
        }
      }
      if (data.length === 0) {
        setSubTasks([]);
        setFilteredSubTasks([]);
        if (setTotalSubtasks) {
          setTotalSubtasks([]);
        }
      }
    };
    mastersocket?.on('checklist', handle_checklist);
    mastersocket?.on('subtasks', handle_subtasks);
    return () => {
      mastersocket?.off('checklist', handle_checklist);
      mastersocket?.off('subtasks', handle_subtasks);
    };
  }, [milestoneId, socket]);

  const handleAddTask = (data) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, milestone?.projectBoardId);
      selectedBoardId = milestone?.projectBoardId;
    }
    if (isSubTask) {
      masterSocket.emit('add-subtask', { ...data, milestoneId }, selectedBoardId);
    } else {
      const { status, ...rest } = data;
      let formattedFormData = rest;
      if (showSubTask) {
        masterSocket.emit('add-checklist', { ...formattedFormData, subtaskId: subTaskId }, selectedBoardId);
      } else {
        masterSocket.emit('add-checklist', { ...formattedFormData, milestoneId }, selectedBoardId);
      }
    }
  };

  const findChecklistById = (items, id) => {
    for (const item of items || []) {
      if (item._id === id) {
        return item;
      }

      if (item.children?.length > 0) {
        const found = findChecklistById(item.children, id);
        if (found) return found;
      }
    }

    return null;
  };

  const handleChecked = (data, key) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, milestone?.projectBoardId);
      selectedBoardId = milestone?.projectBoardId;
    }
    const existingTask = isSubTask
      ? subTasks.find((task) => task._id === data._id)
      : findChecklistById(tasks, data._id);
    if (!existingTask) return;

    const normalizeAssignees = (assignees) =>
      assignees
        ?.map((a) => (typeof a === 'string' ? a : a._id))
        .sort()
        .join(',');

    const hasChanged =
      existingTask?.name !== data?.name ||
      existingTask?.dueDate !== data?.dueDate ||
      existingTask?.status?._id !== data?.status ||
      existingTask?.isCompleted !== data?.isCompleted ||
      normalizeAssignees(existingTask.assignees || []) !== normalizeAssignees(data.assignees || []);

    if (!hasChanged) return; // Exit if nothing changed

    let payload = {
      milestoneId: data.milestoneId || milestoneId
    };

    // Add only the specified key to the payload
    if (key) {
      switch (key) {
        case 'name':
          payload.name = data.name;
          break;
        case 'dueDate':
          payload.dueDate = data.dueDate;
          payload.dueDateString = data?.dueDateString;
          payload.kbDueDateReminders = data?.kbDueDateReminders;
          break;
        case 'status':
          payload.status = data.status;
          break;
        case 'isCompleted':
          payload.isCompleted = data.isCompleted;
          break;
        case 'assignees':
          payload.assignees = typeof data.assignees[0] === 'string' ? data.assignees : data.assignees.map((x) => x._id);
          break;
        case 'all':
          payload.name = data.name;
          payload.dueDate = data.dueDate;
          payload.status = data.status;
          payload.assignees = typeof data.assignees[0] === 'string' ? data.assignees : data.assignees.map((x) => x._id);
          if (!isSubTask) {
            payload.isCompleted = data.isCompleted;
          }
          break;
        // Add more cases as needed
        default:
          return; // Exit if key is not recognized
      }
    }
    console.log(data, 'datadata');
    if (isSubTask) {
      masterSocket.emit('update-subtask', { id: data._id, milestoneId, payload, projectBoardId: selectedBoardId });
    } else {
      if (showSubTask) {
        masterSocket.emit('update-checklist', { id: data._id, subtaskId: subTaskId, payload }, selectedBoardId);
      } else {
        masterSocket.emit('update-checklist', { id: data._id, milestoneId, payload }, selectedBoardId);
      }
    }
  };

  const handleDelete = (data) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, milestone?.projectBoardId);
      selectedBoardId = milestone?.projectBoardId;
    }
    setDeleting(true);
    if (isSubTask) {
      masterSocket?.emit('delete-subtask', { id: data._id, milestoneId }, selectedBoardId);
    } else {
      if (showSubTask) {
        masterSocket?.emit('delete-checklist', { id: data._id, subtaskId: subTaskId }, selectedBoardId);
      } else {
        masterSocket?.emit('delete-checklist', { id: data._id, milestoneId }, selectedBoardId);
      }
    }
    setDeleting(false);
  };

  const handleMyTask = () => {
    if (!isMyTaskChecked) {
      const filterTasks = tasks.filter((task) =>
        task.assignees?.some((assignee) =>
          typeof assignee === 'string' ? assignee === user._id : assignee?._id === user._id
        )
      );
      setFilteredTasks(filterTasks);
    } else {
      setFilteredTasks(tasks);
    }

    setIsMyTaskChecked(!isMyTaskChecked);
  };

  return (
    <div className={style.task_main_wrapper}>
      <div  className={style.task_mycheck_wrapper}>
        {/* <HeadingWithIcon icon={CHECK_SQUARE2_ICON} heading="Task"> */}
        {/* <div></div> */}
        {!isSubTask && tasks?.length > 0 && (
          <div className={style.my_task_checkbox}>
            <Form>
              <Form.Check // prettier-ignore
                style={{ textAlign: 'right' }}
                type={'checkbox'}
                label="My Checklist"
                checked={isMyTaskChecked || false}
                onChange={handleMyTask}
                disabled={viewMode}
              />
            </Form>
          </div>
        )}
        {/* </HeadingWithIcon> */}
      </div>
      {!showSubTask && isSubTask ? (
        <Tasks
          viewMode={viewMode}
          milestoneId={milestoneId}
          tasks={filteredSubTasks}
          handleAddTask={handleAddTask}
          handleChecked={handleChecked}
          members={members}
          statusOptions={statusOptions}
          isSubTask={isSubTask}
          handleDelete={handleDelete}
          fetchSubtask={fetchSubtask}
          isDeleting={isDeleting}
          reminderOptions={reminderOptions}
          handleAddTaskcsection={handleAddTaskcsection}
        />
      ) : (
        <ChecklistContainer
          sections={filteredTasks}
          viewMode={viewMode}
          milestoneId={milestoneId}
          handleAddTask={handleAddTask}
          handleChecked={handleChecked}
          members={members}
          statusOptions={statusOptions}
          showSubTask={showSubTask}
          handleDelete={handleDelete}
          fetchSubtask={fetchSubtask}
          isDeleting={isDeleting}
          reminderOptions={reminderOptions}
          handleAddTaskcsection={handleAddTaskcsection}
          projectBoardId={projectBoardId}
          subtaskId={subTaskId}
          isChecklistFullscreen={isChecklistFullscreen}
          setIsChecklistFullscreen={setIsChecklistFullscreen}
        />
      )}
    </div>
  );
}
